import { useMemo } from 'react';

import { SongMediaVideo } from '@/core/db.ts';

interface MediaVideoProps {
  mediaFile: SongMediaVideo;
}

function MediaVideo({ mediaFile }: MediaVideoProps) {
  const source = useMemo(() => {
    if (!mediaFile || !mediaFile.contents) {
      return '';
    }

    const blob = new Blob([mediaFile.contents], { type: 'video' });

    return URL.createObjectURL(blob);
  }, [mediaFile]);

  return (
    <div className="aspect-video">
      {/* eslint-disable-next-line jsx-a11y/media-has-caption */}
      <video controls src={source} />
    </div>
  );
}

export default MediaVideo;
